(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__mhCardSwatchesV1) return;
  window.__mhCardSwatchesV1 = true;
  const pending = new WeakMap();

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const swatch = event.target.closest('button[data-mh-card-swatch]');
    if (!swatch || swatch.disabled) return;
    const card = swatch.closest('.product-card-wrapper');
    const image = card?.querySelector('.card__media img');
    const rawUrl = swatch.dataset.mhImageUrl;
    if (!card || !image || !rawUrl) return;

    let imageUrl;
    try {
      imageUrl = new URL(rawUrl, window.location.href);
      if (imageUrl.protocol !== 'https:' && imageUrl.protocol !== 'http:') return;
    } catch {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    const token = {};
    pending.set(card, token);
    card.setAttribute('aria-busy', 'true');
    const preview = new Image();
    const finish = () => {
      if (pending.get(card) !== token) return false;
      pending.delete(card);
      card.removeAttribute('aria-busy');
      return card.isConnected && swatch.isConnected && image.isConnected;
    };

    preview.onload = () => {
      if (!finish()) return;
      image.removeAttribute('srcset');
      image.src = imageUrl.href;
      image.alt = swatch.dataset.mhImageAlt || image.alt;
      card.classList.add('mh-swatch-preview');
      card.querySelectorAll('button[data-mh-card-swatch]').forEach((button) => {
        button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
      });
    };
    preview.onerror = () => { finish(); };
    preview.src = imageUrl.href;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-classic-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-product-facts')) {
    customElements.define('mh-product-facts', class extends HTMLElement {
      connectedCallback() {
        const description = this.closest('.mh-classic__details')?.querySelector('.mh-classic__description > .rte');
        const list = this.querySelector('ul');
        if (!description || !list || list.children.length) return;
        const clean = value => value.replace(/[\u2010-\u2015]/g, '-').replace(/\s+/g, ' ').trim();
        const policyOrInstructions = /\b(shipping|returns?|refund|delivery|upload|click|select|checkout|cart|contact us|proof approval|artwork|dpi|ppi)\b/i;
        const facts = [];
        const add = value => {
          const text = clean(value);
          if (text && !facts.some(fact => fact.toLowerCase().includes(text.toLowerCase()))) facts.push(text);
        };
        // Reuse the merchant's own feature bullets when available.
        description.querySelectorAll('ul > li').forEach(item => {
          const text = clean(item.textContent);
          if (text.length <= 220 && !policyOrInstructions.test(text)) add(text);
        });
        if (!facts.length) {
          const text = clean(description.textContent);
          // Quote existing specifications, including material exceptions.
          const patterns = [
            /\b(?:classic|relaxed|regular|athletic|slim|modern|unisex)[ -]fit(?:ting)?\b/i,
            /\b\d+(?:\.\d+)?\s*oz\.?(?:\s*\/\s*yd[²2])?/i,
            /\b\d+(?:\.\d+)?%\s*(?:(?:soft|durable|combed|ring[ -]spun|recycled|organic|preshrunk|and)\s+)*(?:cotton|polyester|nylon|acrylic|wool|rayon|spandex|bamboo)(?:\s*\/\s*\d+%\s*\w+)*(?:\s*\([^)]*\))?/i,
            /\btear[ -]?away\s+(?:neck\s+)?label\b/i,
            /\bdouble[ -]wall(?:ed)?(?:\s+design)?(?:\s+for\s+[^.!?]+retention)?/i,
            /\bpowder[ -]coated\s+(?:matte\s+)?finish\b/i,
            /\bmaximum print area(?:\s+of|:)?\s+\d+(?:\.\d+)?\s*(?:inches|in|["″])?\s*(?:by|x|×)\s*\d+(?:\.\d+)?\s*(?:inches|in|["″])/i,
            /\b(?:measuring|dimensions:?)\s+\d+(?:\.\d+)?\s*(?:inches|in|["″])?\s*(?:by|x|×)\s*\d+(?:\.\d+)?\s*(?:inches|in|["″])/i,
            /\b\d+(?:\.\d+)?[ -]*(?:inches|inch|in|["″])\s*(?:by|x|×)[ -]*\d+(?:\.\d+)?[ -]*(?:inches|inch|in|["″])/i,
            /\bprint is on one side(?: of [^.!?]+)?/i,
            /\b(?:zipper|zippered|zip|front|side|kangaroo)\s+pocket(?:s)?\b/i,
            /\b(?:crew|v)[ -]neck\b/i
          ];
          patterns.forEach(pattern => {
            const match = text.match(pattern);
            if (match) add(match[0]);
          });
          // Keep unfamiliar specifications verbatim rather than inventing claims.
          if (!facts.length) {
            description.querySelectorAll('p').forEach(paragraph => {
              const text = clean(paragraph.textContent);
              if (text.length <= 180 && /\b(fabric|material|dimensions|capacity|weight|fit|lining|closure)\b/i.test(text) &&
                !policyOrInstructions.test(text)) add(text);
            });
          }
        }
        facts.slice(0, 6).forEach(text => {
          const item = document.createElement('li');
          item.textContent = text.charAt(0).toUpperCase() + text.slice(1);
          list.append(item);
        });
        this.hidden = !list.children.length;
        this.shortenDescription(description);
      }

      shortenDescription(description) {
        const section = description.closest('.mh-classic__description');
        const excerpt = section.querySelector('.mh-classic__excerpt');
        const more = section.querySelector('.mh-classic__more');
        if (!excerpt || !more || !more.hidden) return;
        const clean = value => value.replace(/\s+/g, ' ').trim();
        const fullText = clean(description.textContent);
        if (!fullText) return;
        const paragraphs = [...description.querySelectorAll('p')]
          .map(paragraph => clean(paragraph.textContent)).filter(Boolean);
        const introduction = paragraphs.find(text => text.split(/\s+/).length >= 8) || paragraphs[0] || fullText;
        const sentences = typeof Intl.Segmenter === 'function'
          ? [...new Intl.Segmenter(document.documentElement.lang || 'en', { granularity: 'sentence' }).segment(introduction)].map(item => item.segment)
          : [introduction];
        let summary = '';
        for (const sentence of sentences) {
          if (clean(summary + sentence).split(/\s+/).length > 65) break;
          summary += sentence;
        }
        summary = clean(summary) || introduction.split(/\s+/).slice(0, 65).join(' ') + '…';
        // Already-short descriptions need no extra disclosure control.
        if (fullText === summary && !description.querySelector('img, table, ul, ol')) return;
        const paragraph = document.createElement('p');
        paragraph.textContent = summary;
        excerpt.append(paragraph);
        excerpt.hidden = false;
        // Retain every original paragraph, link and instruction; gallery video discovery
        // still finds the same .rte inside this disclosure, regardless of script order.
        more.append(description);
        more.hidden = false;
        if (/\b(artwork|customiz\w*|embroid\w*|engrav\w*|laser|print(?:ing)?|proof|dpi|ppi)\b/i.test(fullText)) {
          more.querySelector('[data-product-more]').hidden = true;
          more.querySelector('[data-customization-more]').hidden = false;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mh-pricing-calculator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mh-pricing-calculator')) {
    class MHPricingCalculator extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.scope = this.closest('product-info');
        if (!this.scope || this.dataset.currency !== 'USD' || !this.dataset.locale.startsWith('en')) return;
        this.controller = new AbortController();
        this.number = this.querySelector('[data-quantity]');
        this.slider = this.querySelector('[data-slider]');
        this.status = this.querySelector('[data-status]');
        this.summary = this.querySelector('.mh-calc__summary');
        this.button = this.scope.querySelector('.custom-customize__button');
        this.cartForm = document.getElementById(this.dataset.formId);
        if (!this.button && !this.cartForm) return;
        this.cartFallback = this.querySelector('[data-cart-quantity]');
        this.cartQuantity = [...(this.cartForm?.elements || [])].find(input => input.name === 'quantity' && input !== this.cartFallback);
        this.variantMappings = JSON.parse(this.querySelector('[data-variant-mappings]').textContent);
        this.baseHref = this.button?.href;
        this.quantity = Number(this.cartQuantity?.value) || 1;
        this.number.value = String(this.quantity);
        this.slider.value = String(this.quantity);
        this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
        const signal = this.controller.signal;
        this.number.addEventListener('input', () => {
          if (this.number.value !== '' && this.number.validity.valid) this.setQuantity(this.number.value);
        }, { signal });
        this.number.addEventListener('change', () => this.setQuantity(this.number.value), { signal });
        this.slider.addEventListener('input', () => this.setQuantity(this.slider.value), { signal });
        this.cartQuantity?.addEventListener('change', () => {
          if (!this.hidden) this.setQuantity(this.cartQuantity.value);
        }, { signal });
        window.addEventListener('pageshow', () => {
          // History navigation can restore form values after the component initializes.
          clearTimeout(this.restoreTimer);
          this.restoreTimer = setTimeout(() => {
            this.setQuantity(this.number.value);
            this.refresh();
          }, 0);
        }, { signal });
        this.scope.addEventListener('change', event => {
          if (event.target.closest('variant-selects')) {
            this.pending = true;
            this.showPending();
            this.schedule();
          }
        }, { capture: true, signal });
        this.button?.addEventListener('click', event => {
          if (this.pending && !this.hidden) {
            event.preventDefault();
            this.showPending();
            return;
          }
          this.updateDesignerLink();
        }, { capture: true, signal });
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.scope, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href', 'value', 'style', 'class', 'hidden', 'aria-hidden'] });
        this.refresh();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        clearTimeout(this.restoreTimer);
        this.hideCalculator();
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.refresh(); });
      }

      selectedVariant() {
        try {
          const node = this.scope.querySelector('variant-selects [data-selected-variant]');
          const variant = JSON.parse(node?.textContent || this.querySelector('[data-initial-variant]').textContent);
          const fields = [...this.scope.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown')];
          const options = fields.map(field => field.querySelector('input:checked')?.value || field.querySelector('select')?.value).filter(Boolean);
          if (options.length && options.some((option, index) => option !== variant.options[index])) return null;
          return variant;
        } catch { return null; }
      }

      cents(text) {
        const match = String(text || '').trim().match(/^\$\s*([\d,]+\.\d{2})\s*$/);
        return match ? Math.round(Number(match[1].replaceAll(',', '')) * 100) : NaN;
      }

      readTiers(source, base) {
        // An absent/disabled Dealeasy offer must never produce a calculator.
        if (source.closest('[hidden], [aria-hidden="true"]') || source.style.display === 'none') return null;
        const rows = [...source.querySelectorAll('.lb-qty-selector-tier-wrapper')];
        if (!rows.length) return null;
        const tiers = [];
        for (const row of rows) {
          const range = row.querySelector('.lb-qty-selector-quantity-text')?.textContent.trim().match(/^Buy\s+(\d+)\s*(?:[-–]\s*(\d+)|(\+))$/i);
          const price = this.cents(row.querySelector('.lb-qty-selector-discounted-price-text .money')?.textContent);
          const original = this.cents(row.querySelector('.lb-qty-selector-original-price-text > span:last-child')?.textContent);
          const saving = row.querySelector('.lb-qty-selector-discount-text')?.textContent.match(/([\d.]+)%/);
          if (!range || !Number.isFinite(price) || original !== base || price <= 0 || price > base || !saving) return null;
          tiers.push({ min: Number(range[1]), max: range[3] ? Infinity : Number(range[2]), price, saving: Number(saving[1]) });
        }
        tiers.sort((a, b) => a.min - b.min);
        if (tiers[0].min < 2) return null;
        tiers.unshift({ min: 1, max: tiers[0].min - 1, price: base, saving: 0 });
        if (tiers.some((tier, index) => tier.max < tier.min || (index && tier.min !== tiers[index - 1].max + 1))) return null;
        if (!tiers.some(tier => tier.price < base && tier.saving > 0)) return null;
        return tiers;
      }

      hideCalculator() {
        this.hidden = true;
        this.tiers = null;
        this.readySignature = null;
        if (this.source?.classList.contains('mh-calc-source')) this.source.classList.remove('mh-calc-source');
        this.source = null;
        if (this.cartFallback) this.cartFallback.disabled = true;
        if (this.designerHref && this.button?.href === this.designerHref) this.button.href = this.nativeHref;
        this.designerHref = null;
      }

      refresh() {
        const variant = this.selectedVariant();
        if (!variant) { this.pending = true; this.showPending(); return; }
        this.variant = variant;
        this.pending = false;
        const source = this.scope.querySelector('lb-vd-qty-selector');
        const tiers = source && this.readTiers(source, variant.price);
        if (!tiers || !variant.available) {
          this.hideCalculator();
          return;
        }
        if (this.source !== source) this.hideCalculator();
        this.source = source;
        this.tiers = tiers;
        const rule = variant.quantity_rule || {};
        this.number.min = String(rule.min || 1);
        this.number.max = String(rule.max || 99999);
        this.number.step = String(rule.increment || 1);
        this.slider.min = this.number.min;
        this.slider.step = this.number.step;
        this.querySelector('[data-minimum-label]').hidden = (rule.min || 1) > 1;
        if (this.quantity < (rule.min || 1) || this.quantity > (rule.max || 99999)) this.setQuantity(this.quantity);
        const signature = `${variant.id}:${this.quantity}:${JSON.stringify(tiers)}`;
        if (this.readySignature === signature && !this.summary.hidden && !this.hidden) {
          this.updateDesignerLink();
          return;
        }
        this.readySignature = signature;
        this.hidden = false;
        this.summary.hidden = false;
        this.status.hidden = true;
        if (!source.classList.contains('mh-calc-source')) source.classList.add('mh-calc-source');
        this.render();
        this.updateDesignerLink();
      }

      showPending() {
        if (this.hidden) return;
        this.summary.hidden = true;
        this.status.hidden = false;
        this.status.textContent = this.dataset.loading;
      }

      setQuantity(value) {
        const parsed = Number(value);
        const rule = this.variant?.quantity_rule;
        const minimum = rule?.min || 1;
        const increment = rule?.increment || 1;
        const maximum = Math.min(rule?.max || 99999, 99999);
        const requested = Number.isFinite(parsed) ? Math.floor(parsed) : minimum;
        this.quantity = Math.max(minimum, Math.min(maximum, minimum + Math.floor((requested - minimum) / increment) * increment));
        this.number.value = String(this.quantity);
        this.slider.max = String(Math.max(150, this.quantity));
        this.slider.value = String(this.quantity);
        if (this.tiers && !this.pending) this.render();
        this.updateDesignerLink();
      }

      render() {
        const tier = this.tiers.find(item => this.quantity >= item.min && this.quantity <= item.max);
        if (!tier) { this.showPending(); return; }
        this.querySelector('[data-unit]').textContent = this.money.format(tier.price / 100);
        this.querySelector('[data-total]').textContent = this.money.format(tier.price * this.quantity / 100);
        this.querySelector('[data-total-note]').textContent = `${this.quantity} ${this.quantity === 1 ? this.dataset.oneBeforeTax : this.dataset.beforeTax}`;
        const original = this.querySelector('[data-original]');
        original.hidden = tier.saving === 0;
        original.textContent = this.money.format(this.variant.price / 100);
        const saving = this.querySelector('[data-saving]');
        saving.hidden = tier.saving === 0;
        saving.textContent = `${tier.saving}% ${this.dataset.savings}`;
      }

      updateDesignerLink() {
        if (!this.variant || this.pending || !this.tiers || this.hidden) return;
        if (!this.button) {
          const quantityInput = this.cartQuantity || this.cartFallback;
          if (quantityInput) {
            quantityInput.disabled = false;
            quantityInput.value = String(this.quantity);
          }
          return;
        }
        const entries = typeof variants_for_deco !== 'undefined' && Array.isArray(variants_for_deco) ? variants_for_deco : [];
        const exact = entries.find(entry => String(entry.id) === String(this.variant.id));
        const sameColor = entries.find(entry => entry.title.split(' / ')[0] === this.variant.options[0]);
        const sameSize = entries.find(entry => entry.title.split(' / ')[1] === this.variant.options[1]);
        try {
          const url = new URL(exact?.URL || this.baseHref);
          if (url.hostname !== 'matohash.secure-decoration.com' || url.pathname !== '/external/load_resource') return;
          let size = exact && url.searchParams.get('size');
          let color = exact && url.searchParams.get('color_id');
          if (!size && sameSize) size = new URL(sameSize.URL).searchParams.get('size');
          if (!size && this.variant.options[1] === 'Small') size = this.dataset.smallSizeId;
          if (!color && sameColor) color = new URL(sameColor.URL).searchParams.get('color_id');
          const colorIndex = Number(this.dataset.colorPosition ?? 1) - 1;
          const sizeIndex = Number(this.dataset.sizePosition ?? 2) - 1;
          if (this.variantMappings) {
            const mapping = this.variantMappings.find(entry => String(entry.id) === String(this.variant.id));
            const sameOption = (index, key) => {
              if (index < 0) return null;
              const values = [...new Set(this.variantMappings.filter(entry => entry.options[index] === this.variant.options[index]).map(entry => entry[key]).filter(Boolean))];
              return values.length === 1 ? values[0] : null;
            };
            size = mapping?.size || sameOption(sizeIndex, 'size') || (this.variant.options[sizeIndex] === 'Small' ? this.dataset.smallSizeId : null);
            color = mapping?.color || sameOption(colorIndex, 'color');
          }
          const ready = (sizeIndex < 0 || /^\d+$/.test(size || '')) && (colorIndex < 0 || /^\d+$/.test(color || ''));
          this.querySelector('[data-handoff-note]').hidden = ready;
          url.searchParams.set('size', size || '');
          url.searchParams.set('color_id', color || '');
          url.searchParams.set('oid', String(this.variant.id));
          url.searchParams.set('quantity', String(this.quantity));
          const next = url.toString();
          if (this.button.href !== next) {
            if (this.button.href !== this.designerHref) this.nativeHref = this.button.href;
            this.designerHref = next;
            this.button.href = next;
          }
        } catch {
          this.querySelector('[data-handoff-note]').hidden = false;
        }
      }
    }
    customElements.define('mh-pricing-calculator', MHPricingCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
